import React from "react"
import PropTypes from "prop-types"

import lottie from 'lottie-web'

class EarlyMemberAlert extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      city: '',
      stateName: '',
    }

    this.onFbClick = this.onFbClick.bind(this)
    this.onTwitterClick = this.onTwitterClick.bind(this)
  }

  componentWillMount() {
    let city = this.props.user.location.split(/,/)[0]
    let state = this.props.user.location.split(/, /)[1]
    this.setState({
      city: city,
      stateName: state
    })
  }

  componentDidMount() {
      lottie.loadAnimation({
        container: document.getElementById('facebook'),
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: this.props.facebook_icon
      });
      lottie.loadAnimation({
        container: document.getElementById('twitter'),
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: this.props.twitter_icon
      });
  }


  onTwitterClick() {
    window.open(`//twitter.com/intent/tweet?text=Learning%20a%20language?%20Practice speaking,%20in%20person,%20with%20native%20speakers%20on%20%40LexodyApp!%20Use%20my%20code:%20www.lexody.com/?referral_code=LEX50${this.props.user.id}`, "_blank")
  }
  onFbClick() {
    window.open(`//www.facebook.com/sharer/sharer.php?u=https%3A//www.lexody.com/?referral_code=LEX50${this.props.user.id}`, "_blank")
  }


  render() {
      return (
        <div  className="wrapper_form_dark" style={{padding: 24, marginLeft: 12, marginRight: 12, margin: 'auto', marginBottom: 12, maxWidth: '94%', marginBottom: 12, padding: 24, textAlign: 'center'}}>
          <h4 style={{fontWeight: '600', paddingBottom: 12, fontSize: 20}}>Thanks for being an early {this.state.city} member!</h4>
          <br />
          <h4>Lexody will launch into {this.state.city} when at least<br />500 members sign up in {this.state.city}.</h4>
          <br />
          <h4>You will have <span style={{color: '#F48FB1', fontWeight: 600}}>1-year free Pro access</span> to Lexody!</h4>
          <hr style={{borderColor: '#F48FB1', borderTopWeight: 2, maxWidth: '75%', margin: 'auto', marginTop: 24}}/>
          <hr style={{borderColor: '#F48FB1', borderTopWeight: 2, maxWidth: '75%', margin: 'auto', marginBottom: 24}}/>

          <h4>Invite friends in {this.state.city} to join<br />for <span style={{color: '#F48FB1', fontWeight: '600'}}>free Pro access</span> for a year!</h4>
          <div style={{margin: 'auto', marginTop: 24, width: 250, height: 75, backgroundColor: 'rgba(255, 255, 255, .5)', borderRadius: 3, padding: 12}}>
            <p>My Referral Code</p>
            <h2 className="darkBlue" style={{marginTop: 3, fontWeight: '600'}}>LEX50{this.props.user.id}</h2>
          </div>
          <div style={{margin: 'auto', marginTop: 12, cursor: 'pointer'}}>
            <div id="facebook" className="social_share_icons" onClick={this.onFbClick}></div>
            <div id="twitter" className="social_share_icons" onClick={this.onTwitterClick}></div>
          </div>
        </div>
      )
  }
}

export default EarlyMemberAlert;
